<template>
	<div>
		<!-- <div class="pageTopBox space_between">
			<div class="titleText">媒体对账单</div>
			<div class="addBtn">
				<el-button type="success" icon="el-icon-edit-outline" size="small" @click="calculationAllFun"
				v-hasPermi="['financeAccount:mediaAccount:count']">计算</el-button>
				<el-button type="primary" icon="el-icon-document" size="small" @click="settlementDocAllFun"
				v-hasPermi="['financeAccount:mediaAccount:creatAccount']">生成</el-button>
				<el-button type="primary" icon="el-icon-refresh" size="small" @click="syncAllFun"
				v-hasPermi="['financeAccount:mediaAccount:async']">同步</el-button>
			</div>
		</div> -->
		<div class="mianPage">
			<div class="topSearch">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-date-picker v-model="datePicker" value-format="yyyy-MM" type="monthrange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" size="small">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.companyId" clearable filterable size="small" style="width:210px" placeholder="请选择所属公司">
							<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.syncStatus" clearable size="small" style="width:210px" placeholder="请选择同步状态">
							<el-option label="未同步" :value="0"></el-option>
							<el-option label="已同步" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<div class="menu-right">
						<el-button @click="searchReset" size="small" v-hasPermi="['financeAccount:mediaAccount:query']">重置</el-button>
						<el-button type="primary" @click="confirmQuery" size="small" v-hasPermi="['financeAccount:mediaAccount:query']">查询</el-button>
					</div>
				</el-form>
			</div>
			<!-- table表格 -->
			<div class="tableBox">
				<div class="addBtn">
					<el-button type="success" icon="el-icon-edit-outline" size="small" @click="calculationAllFun"
					v-hasPermi="['financeAccount:mediaAccount:count']">计算</el-button>
					<el-button type="primary" icon="el-icon-document" size="small" @click="settlementDocAllFun"
					v-hasPermi="['financeAccount:mediaAccount:creatAccount']">生成</el-button>
					<el-button type="primary" icon="el-icon-refresh" size="small" @click="syncAllFun"
					v-hasPermi="['financeAccount:mediaAccount:async']">同步</el-button>
				</div>
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
					class="el_table" @selection-change="handleSelectionChange" ref="multipleTable">
					<el-table-column type="selection" :selectable="checkSelectable" width="55">
					</el-table-column>
					<el-table-column prop="month" label="业务时间" width="140"></el-table-column>
					<el-table-column prop="companyName" label="所属公司" width="200"></el-table-column>
					<el-table-column prop="cooperationState" label="合作状态" width="100">
						<template slot-scope="scope">
							<div v-if="scope.row.cooperationState === 1">未合作</div>
							<div v-if="scope.row.cooperationState === 2">合作中</div>
							<div v-if="scope.row.cooperationState === 3">跟进中</div>
							<div v-if="scope.row.cooperationState === 4">暂停合作</div>
							<div v-if="scope.row.cooperationState === 5">其他</div>
						</template>
					</el-table-column>
					<el-table-column prop="profit" label="收益">
						<template slot-scope="scope">
							<el-popover placement="right" width="300" trigger="hover">
								<el-table :data="scope.row.profitDetails" max-height="500">
									<el-table-column align="center" width="150" property="profitDate" label="日期"></el-table-column>
									<el-table-column align="center" min-width="100" property="estimateProfit"
										label="收益"></el-table-column>
								</el-table>
								<el-button slot="reference">{{scope.row.profit}}</el-button>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="cut" label="核减" width="150">
						<template slot-scope="scope">
							<el-input-number v-model="scope.row.cut" style="width: 120px" controls-position="right" :step="1"
								:min="0"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column prop="cutProfit" label="核减后收益"></el-table-column>
					<el-table-column prop="invoiceDiff" label="发票差价%" width="100">
						<template slot-scope="scope">
							<div v-if="scope.row.cultureConstructionSwitch == 0" class="strikethrough">{{ scope.row.invoiceDiff }}</div>
							<div v-else>{{ scope.row.invoiceDiff }}</div>
						</template>
						<!-- <template slot-scope="scope">
							<el-input class="el-inputs" v-model="scope.row.invoiceDiff" @blur="invoiceDiffChange(scope.row)" style="width: 120px;" ></el-input>
						</template> -->
					</el-table-column>
					<el-table-column prop="valueAddDiff" label="增值税差价%">
						<template slot-scope="scope">
							<div v-if="scope.row.valueAddTaxSwitch == 0" class="strikethrough">{{ scope.row.valueAddDiff }}</div>
							<div v-else>{{ scope.row.valueAddDiff }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="finalProfit" label="最终收益"></el-table-column>
					<el-table-column prop="" label="结算单" width="90px">
						<template slot-scope="scope">
							<el-button size="medium" :disabled="!scope.row.finalStatementUrl" type="text" @click="downloadFile(scope.row)"
							v-hasPermi="['financeAccount:mediaAccount:download']">查看</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="syncStatus" label="状态" width="100">
						<template slot-scope="scope">
							<div v-if="scope.row.syncStatus === 0">未同步</div>
							<div v-if="scope.row.syncStatus === 1">已同步</div>
						</template>
					</el-table-column>
					
					<el-table-column prop="" label="操作" fixed="right" width="200">
						<template slot-scope="scope">
							<el-button type="text" @click="calculationFun(scope.row,scope.$index)"
							v-hasPermi="['financeAccount:mediaAccount:count']">计算</el-button>
							<el-button type="text" @click="settlementDocFun(scope.row)"
							v-hasPermi="['financeAccount:mediaAccount:creatAccount']">生成结算单</el-button>
							<el-button type="text" @click="syncFun(scope.row.id)" :disabled="scope.row.syncStatus!==0"
							v-hasPermi="['financeAccount:mediaAccount:async']">同步</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="currentPage"
						:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainHeadTitle: '媒体对账单',
				datePicker: [],
				appSelectData: [], // APP下拉选择列表
				companyOptions: [], // 公司下拉选择列表
				queryData: {},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				appRulesApi: {
					adName: [{
						required: true,
						message: '请选择所属应用',
						trigger: 'blur'
					}, ],
					downloadLink: [{
						required: true,
						message: '请输入下载地址',
						trigger: 'blur'
					}, ],
				},
				appFormData: {
					isList: 1
				},

				dialogVisible: false, // 弹框显隐
				handleSelection: [], // 表格选中项
			}
		},
		mounted() {
			this.getCompanyOption();
			// this.getAppOption();
			this.getTableData();
		},
		methods: {
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					// appId: this.queryData.appId,
					startMonth: '',
					endMonth: '',
				}
				if (this.datePicker && this.datePicker.length>0) {
					data.startMonth = this.datePicker[0];
					data.endMonth = this.datePicker[1];
				}
				data = {...data,...this.queryData}
				let res = await this.$http.post(this.$api.financeAccount.mediaAccountList, data);
				this.tableData = res.data.list
				this.total = res.data.totalRecord
			},
			async getAppOption(){
				let res = await this.$http.get(this.$api.common.appOption);
				if(res.code == 1){
					this.appSelectData = res.data
				}
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			
			// 发票差价
			async invoiceDiffChange(row){
				let data = {
					id: row.id,
					invoiceDiff: row.invoiceDiff?row.invoiceDiff:0
				}
				let res = await this.$http.post(this.$api.companyList,data);
				if(res.code == 200){
					this.$message.success('发票差价修改成功')
					this.getTableData(); // 刷新
				}
			},
			// 下载结算单
			downloadFile(item) {
				let a = document.createElement('a')
				a.href = item.finalStatementUrl
				a.click();
			},
			// 同步
			async syncFun(row) {
				let data = row.length ? row : [row];
				let res = await this.$http.post(this.$api.financeAccount.mediaAccountSync,data);
				if (res.code == 1) {
					this.getTableData(); // 刷新
					this.$message.success('同步成功！');
				}
			},
			// 生成全部结算单
			settlementDocAllFun(){
				let data = this.handleSelection;
				if (data === "" || !data.length) {
					this.$message.warning("请选择生成项！");
					return
				}
				this.settlementDocFun('all');
				
				// this.$confirm('此操作将选中项全部生成结算单, 是否继续?', '提示', {
				// 	confirmButtonText: '确定',
				// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(async () => {
					
				// }).catch();
			},
			// 生成结算单
			settlementDocFun(row){
				this.$confirm('此操作将生成结算单, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let data = []
					if (row === "all") {
						data = this.handleSelection;
						data = data.map(item => {
							return item.id
						})
						this.$refs.multipleTable.clearSelection(); // 清空选项
						console.log(data)
					} else {
						data.push(row.id)
					}
					let res = await this.$http.post(this.$api.financeAccount.createBill,data);
					if(res.code == 1){
						this.$message.success('结算单生成成功')
						this.getTableData(); // 刷新
					}
				}).catch();
			},
			// 计算
			async calculationFun(row) {
				let data = [];
				if (row === "all") {
					data = this.handleSelection;
					data = data.map(item => {
						return {"reviewReduce":item.reviewReduce,"id":item.id}
					})
					// console.log(data)
				} else {
					data.push({
						"reviewReduce": row.cut,
						"id": row.id,
						// "valueAddDiff":item.valueAddDiff,
						// "invoiceDiff":item.invoiceDiff
					})
				}
				let res = await this.$http.post(this.$api.financeAccount.calculate,data);
				if(res.code == 1){
					this.$message.success('计算成功！');
					this.getTableData(); // 刷新
				}else{
					this.$message.warning('计算失败！');
				}
			},
			// 计算全部
			calculationAllFun() {
				// console.log(this.handleSelection);
				let data = this.handleSelection;
				if (data === "" || !data.length) {
					this.$message.warning("请选择计算项！");
					return
				}
				this.$confirm('此操作将计算全部, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.calculationFun('all');
					this.$refs.multipleTable.clearSelection(); // 清空选项
				}).catch();
			},
			// 一键同步
			syncAllFun() {
				let data = this.handleSelection;
				if (data === "" || !data.length) {
					this.$message.warning("请选择同步项！");
					return
				}
				data = data.map(item => {
					return item.id
				})
				this.$confirm('此操作将同步收入, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$refs.multipleTable.clearSelection(); // 清空选项
					this.syncFun(data);
				}).catch();
			},
			// 复选框
			handleSelectionChange(val) {
				this.handleSelection = val.map(res => {
					return {
						"reviewReduce": res.cut,
						"id": res.id
					}
				})
			},
			
			// 复选框控制
			checkSelectable(row, index) {
				return true
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}
	
	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
		border-radius: 4px;
	}
	
	.el-form {
		flex-wrap: wrap;
	}
	
	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}
	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}
	
	.menu-right {
		margin-left: auto;
		margin-top: 4px;
		/* margin-bottom: 20px; */
	}
	
	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
		border-radius: 4px;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}

	.card-bottom {
		padding-right: 30px;
	}




	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
		margin-bottom: 16px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}

	.drawerTable {
		margin: 20px 0;
		/* padding: 10px; */
		box-sizing: border-box;
	}

	.box-card /deep/ .el-card__body {
		box-sizing: border-box;
	}
	.strikethrough{
		text-decoration: line-through;
    color: #c71c1c; /* 可选：设置删除线颜色 */
	}
</style>